/**
 * Cdn Edit Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cdnEditFormatter = function(value, row) {
    let html = '';
    switch (row.mime_type) {
        case "image/png":
        case "image/jpeg":
        case "image/jpg":
        case "image/gif":
        case "image/bmp":
        case "image/webp":
            html += '<a href="#" class="cdn-edit" data-id="'+row.id+'">';
            html += '<i class="fas fa-pencil"></i>';
            html += '</a>';
            break;
    }
    return html;
};
